class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    document.addEventListener('cartItemRemoved', () => {
      console.log('cart product remove event received, refreshing cart...');
      this.onCartUpdate();
    });
  }

  cartUpdateUnsubscriber = undefined;
  promoChecked = false;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    // Check for promo cookie and cart

    const urlParams = new URLSearchParams(window.location.search);
    const linkValue = urlParams.get('link');

    console.log('promo cookie: ', this.getCookie('Promo-500'))

    if (linkValue === '500BE' && !this.getCookie('Promo-500')) {
      console.log('klaviyo link found in url');
      this.setCookie('Promo-500', 'true', 1);
      // cartPromo.addProductToCart(42707371524184, 'Email Entry');
    } else if (linkValue === 'PS-link-500' && !this.getCookie('Promo-500')) {
      console.log('PS link found in url')
      this.setCookie('Promo-500', 'true', 1);
      // cartPromo.addProductToCart(42707371524184, 'SMS Entry');
    }

    if (!this.promoChecked) {
      console.log('promo has not been checked')
      const promoInit = this.getCookie('Promo-500');
      if (promoInit) {
        const progressWrapper = document.querySelector('.popup-threhold-bar-wrapper');
        progressWrapper.classList.remove('hidden');
        document.dispatchEvent(new Event('promoCookieFound'));
        this.checkCartAndAddPromo();
        this.promoChecked = true; // Set the flag to true
      }
    }

    this.updateSideCartEntryHub();

    // Check for when user clicks the upgrade promo in side cart
    this.addEventListener('click', (event) => {
      const freeEntryButton = event.target.closest('.free-entry-box');
      if (freeEntryButton) {
        event.preventDefault();
        const itemIndex = freeEntryButton.dataset.itemIndex;
        const variantId = freeEntryButton.dataset.variantId;
        const addnualItem = freeEntryButton.dataset.annualProduct;
        const sellingPlanId = freeEntryButton.dataset.sellingPlanId;
        const tierNumber = freeEntryButton.dataset.tierNumber;

        if (itemIndex && addnualItem) {
          this.replaceCartItem(itemIndex, addnualItem, sellingPlanId, tierNumber);
        }
      }
    });
  }

  checkCartAndAddPromo() {
    console.log('checking promo cookie and cart');
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const VARIANT_ID = 42707371524184;
      const MAX_PROMO_ITEMS = 1;

      // Filter out the promo product from the cart items
      const nonPromoItems = cart.items.filter(item => item.id !== VARIANT_ID);

      // Calculate the total price excluding the promo product
      const CART_TOTAL = nonPromoItems.reduce((total, item) => total + item.final_line_price, 0) / 100;

      // Find promo products in cart
      const promoItems = cart.items.filter(item => item.id === VARIANT_ID);
      console.log('Cart Total', CART_TOTAL);

      if (CART_TOTAL >= 35 && promoItems.length === 0 && MAX_PROMO_ITEMS === 1) {
        console.log('user is over limit and promo product is being added')
        this.addPromoProductToCart(VARIANT_ID, 'SMS Entry')
          .then(() => this.updateCartDrawer(cart));
      } else if (CART_TOTAL < 35) {
        this.promoChecked = false;
        const promoItemIndex = cart.items.findIndex(item => item.id === VARIANT_ID);

        if (promoItemIndex === -1) {
          this.updateProgressBar(cart.total_price / 100);
        } else {
          const promoItem = cart.items[promoItemIndex];
          this.updateQuantity(promoItemIndex + 1, 0, promoItem.properties?.name || 'quantity', VARIANT_ID) // Shopify line items are 1-based index
          .then(() => this.updateCartDrawer(cart));
        }
      }

      this.updateProgressBar(cart.total_price / 100);
    })
    .catch(err => console.error('Error checking cart:', err));
  }

/**
 * Replace a cart item with a new variant, including selling plan and tier-based promo
 * @param {string} itemIndex - The index of the cart item to replace (1-based index)
 * @param {string} newVariantId - The new variant ID to add
 * @param {string} sellingPlanId - The selling plan ID (if applicable)
 * @param {string} tierNumber - The tier number for the promo (if applicable)
 */
replaceCartItem(itemIndex, newVariantId, sellingPlanId, tierNumber) {
  console.log(`Replacing cart item at index ${itemIndex} with variant ${newVariantId} and selling plan ${sellingPlanId}, tier: ${tierNumber}`);

  // First, remove the current item
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: itemIndex, // Shopify uses 1-based index
      quantity: 0, // Remove the item
    }),
  })
  .then((res) => res.json())
  .then(() => {
    console.log(`Item ${itemIndex} removed. Now adding new variant ${newVariantId} with selling plan ${sellingPlanId}`);

    // Prepare request body for adding new variant
    const addPayload = {
      id: newVariantId,
      quantity: 1,
    };

    // Include selling plan ID if it exists
    if (sellingPlanId) {
      addPayload.selling_plan = sellingPlanId;
    }

    const propetyText = tierNumber == 'one' ? '1 month free' : `${tierNumber} months free`;

    // Include tier promo if tierNumber exists
    if (tierNumber) {
      addPayload.properties = {
        promo: `${propetyText}`,
      };
    }

    // Add the new variant with the selling plan and promo (if applicable)
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addPayload),
    });
  })
  .then((res) => res.json())
  .then((cart) => {
    console.log('Cart updated:', cart);
    this.updateCartDrawer(cart);
  })
  .catch((err) => console.error('Error replacing cart item:', err));
}



  addPromoProductToCart(variantId, promo) {
    console.log('adding promo product to cart');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[Promo]', promo);

    return fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(res => res.json())
      .then((cart) => this.updateCartDrawer(cart))
      .catch(err => console.error('Error adding promo product:', err));
  }

  removePromoProductFromCart(lineItemKey) {
    console.log('removing promo product from cart with key:', lineItemKey);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: lineItemKey,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then((cart) => {
        console.log('removed product')
        this.updateCartDrawer(cart);
      })
      .catch(err => console.error('Error removing promo product:', err));
  }

  updateCartDrawer(cart) {
    fetch('/cart?section_id=cart-drawer')
      .then(res => res.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

        selectors.forEach(selector => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });

        // document.querySelector('cart-drawer')?.classList.add('active');

        // Update the progress bar
        this.updateProgressBar(cart.total_price / 100);
      })
      .catch(err => console.error('Error updating cart drawer:', err));
  }

  updateProgressBar(cartTotal) {
    console.log('updating progress bar');
    const threshold = 35; // The threshold value
    const progressBar = document.querySelector('.popup-threhold-bar-wrapper .progress');
    const messageElement = document.querySelector('.popup-threhold-bar-wrapper .message');

    if (progressBar) {
      const progress = Math.min((cartTotal / threshold) * 100, 100); // Calculate progress percentage
      progressBar.style.width = `${progress}%`; // Update the width of the progress bar
    }

    if (messageElement) {
      const amountAway = threshold - cartTotal;
      if (amountAway > 0) {
        messageElement.textContent = `You are $${amountAway.toFixed(2)} away from 500 free entries`;
      } else {
        messageElement.textContent = `🎉 Congratulations! You've earned 500 free entries 🎉`;
      }
    }

    this.promoChecked = true;
  }

  // Check for Promo Cookie
  getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';').map(c => c.trim());
    return cookies.find(c => c.startsWith(nameEQ))?.substring(nameEQ.length) || null;
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value}; path=/;${expires}`;
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  // Update ticket entry header with updated number
  updateSideCartEntryHub() {
    BUILT_USA_DATA.getActiveGiveawaysByCart((giveaways) => {
        giveaways.forEach((giveaway) => {
            if (giveaway.isActive()) {
                const _points = giveaway.getPoints();
                const newPoints = Number(_points);
                const giveawayHeader = document.querySelector('.sidecart-entry-hub-container');

                if (giveawayHeader) {
                    const entryNum = giveawayHeader.querySelector('.entry-total');
                    if (entryNum) {
                        let oldPoints = parseInt((window.pointsOnLoad ? window.pointsOnLoad.replace(/,/g, '') : '0'), 10) || 0;
                        this.animateNumber(entryNum, oldPoints, newPoints);
                    }
                }
            }
        });
    });
  }

  // Easing function for smooth effect
  easeOutQuad(t) {
    return t * (2 - t);
  }

  // Function to format numbers with commas
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Animate ticket entry numbers in side cart
  animateNumber(element, start, end) {
    const duration = 1000; // Animation duration in ms
    const frameRate = 60; // Frames per second
    const totalFrames = (duration / 1000) * frameRate;
    let frame = 0;

    const updateNumber = () => {
        frame++;
        const progress = frame / totalFrames;
        const currentNumber = Math.round(start + (end - start) * this.easeOutQuad(progress));

        element.textContent = this.numberWithCommas(currentNumber);

        if (frame < totalFrames) {
            requestAnimationFrame(updateNumber);
        }
    };

    updateNumber();
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.updateSideCartEntryHub();
          document.dispatchEvent(new Event('cartUpdated'));
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  /**
   *
   */
  refresh() {
    return new Promise(r => {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        if(cart?.items?.length){
          const firstItem = cart.items[0];

          if(firstItem){
            const body = JSON.stringify({
              id: `${firstItem.id}`,
              quantity: firstItem.quantity,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname,
            });

            fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }).then((response) => {
              return response.json();
            }).then((cart) => {
              this.updateTemplateCart(cart);
              r(cart)
            })
          }
        }
      });
    });
  }

  /**
   *
   * @param cart
   */
  updateTemplateCart(cart) {
    this.classList.toggle('is-empty', cart.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        cart.sections[section.section],
        section.selector
      );
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    console.log('Updating Quantity');
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        this.updateTemplateCart(parsedState);

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          document.querySelector('cart-drawer-items').style.display = 'none';
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        this.updateSideCartEntryHub();
        document.dispatchEvent(new Event('cartUpdated'));
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      injectWidget();
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


document.addEventListener('DOMContentLoaded', function() {
    injectWidget();
  })
function injectWidget(){
  BUILT_USA_DATA.getActiveGiveawaysByCart(function(giveaways){
  var mainWidget = '<div class="es-flex es-flex-col es-gap-5">';
  var widgetPlace = document.getElementById('cart-widget-data');
  var widgetPlaceMobile = document.getElementById('cart-widget-data-mobile');
  var cartWidgetTitle = document.querySelector('[data-cart-widget-title]');
  if(cartWidgetTitle && giveaways && giveaways.length)     cartWidgetTitle.innerText = 'Your entries to win';

  giveaways.forEach(function(giveaway){
    if(giveaway.isActive()){
      var name = giveaway.getName();
      var _points = giveaway.getPoints();
      var points = numberWithCommas(_points);
      var image = giveaway.getImageSrc();
      var imageMarkup = image ? `<img src="${image}" alt="${name}" loading="lazy" width="150">`: '';

      mainWidget += `<div class="es-flex es-gap-5 es-items-center">
        <div class="es-w-1/4" style="min-width: 150px">
         ${imageMarkup}
        </div>
        <div class="es-w-3/4">
          <span class="es-font-black es-text-2xl">${name} <span class="es-text-blue-600 es-text-4xl es-px-2">${points} Entries</span></span>
        </div>
      </div>`

      // mainWidget += `
      // <div class="cart-media-app-wrapper">
      //   <img src="${image}" class="cart-item__image" alt="${name}" loading="lazy" width="150">
      // </div>
      // <div class="cart-info-app-wrapper">
      //   <div class="giveaway-app-name">${name}</div>
      //   <div class="giveaway-entries-total"><span class="entries-number-total">${points}</span> Entries</div>
      // </div>`
    }
  })
    mainWidget += '</div>'

    if (window.location.pathname === '/cart') {
       widgetPlace.innerHTML = mainWidget;
       widgetPlaceMobile.innerHTML = mainWidget;
   }
  })
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
